import styled, { css } from 'styled-components';

const StyledContainer = styled.div<{ $fixedWidth?: boolean; $span?: number }>`
	display: flex;
	flex-direction: column;
	gap: 20px;
	align-items: center;
	justify-content: center;
	grid-column: span ${(props) => props.$span || 1};
	${(props) =>
		props.$fixedWidth
			? css`
					width: 600px;
			  `
			: css`
					min-width: 600px;
			  `}
	height: 238px;
	background: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 5px;
`;

const StyledTimerContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

export { StyledContainer, StyledTimerContainer };
